// extracted by mini-css-extract-plugin
export default {"wrapprer":"HowItWorks_wrapprer__pQsR0","container":"HowItWorks_container__gu8LQ","title":"HowItWorks_title__8HoRF","text":"HowItWorks_text__RfgNF"};